<template>
  <div class="character">
    <div class="character_left">
      <img
        :src="list.a"
        class="College-logo"
        v-for="(list, index) in siYuan"
        :key="index"
        :class="{ red: changeRed == index }"
        @click="change(index)"
      />
    </div>
    <div class="character_lefts">
      <img
        :src="list.a"
        class="College-logo"
        v-for="(list, index) in siYuans"
        :key="index"
        :class="{ red: changeRed == index }"
        @click="change(index)"
      />
    </div>
    <div class="character_right">
      <div class="swipers">
        <swiper
          class="swiper_s"
          :options="swiperOption"
          ref="mySwiper"
          @slide-change="changeVoice(0)"
        >
          <!-- slides -->
          <!-- target="_blank" -->
          <swiper-slide
            class="character"
            v-for="(slide, index) in College[changeRed].rolelist"
            :key="index"
          >
            <div class="character_r">
              <p class="title title-s">{{ slide.title }}</p>
              <img
                class="shiroko"
                src="../assets/images/chara/shiroko.png"
                alt=""
              />
              <p class="title name">{{ slide.name }}</p>
              <p class="college Campusinfo">{{ slide.college }}</p>
              <p class="age Campusinfo">{{ slide.age }}</p>
              <p class="birthday Campusinfo">{{ slide.birthday }}</p>
              <p class="stature Campusinfo">{{ slide.stature }}</p>
              <img class="college-logo" :src="slide.logo" alt />
              <div class="frequency">
                <div
                  class="frequencys frequency_l"
                  :class="{ active: audio1playing }"
                >
                  <div class="voiceFrequency" @click="play(index)"></div>
                  <img
                    class="sound"
                    src="../assets/images/chara/sound.png"
                    alt=""
                  />
                  <img
                    class="maiku"
                    src="../assets/images/chara/maiku.png"
                    alt=""
                  />
                  <audio
                    ref="audio1"
                    :src="slide.audio1"
                    preload
                    @pause="audio1playing = false"
                    @ended="audio1playing = false"
                    @playing="audio1playing = true"
                  ></audio>
                </div>
              </div>
              <div class="Useless">
                <div class="Useless_l"></div>
                <div class="Useless_r"></div>
              </div>
            </div>
            <div class="character_l">
              <img
                class="mens"
                :class="slide.changeRed !== '' ? slide.changeRed : ''"
                :src="slide.bannerUrl"
                alt
              />
            </div>
          </swiper-slide>
        </swiper>
        <div class="imgs_s">
          <a
            v-for="(item, index) in College[changeRed].chara"
            @click="swiper.slideTo(index, 1000, false)"
            :key="`imgs_s_${index}`"
          >
            <img class="pager" :src="item.chara1" alt />
            <!-- <img class="" :src="item.chara2" alt /> -->
            <div class="pagers"></div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "character",

  components: {},
  data: () => ({
    siYuan: [
      { a: require("../assets/images/chara/ABYDOS.png") },
      { a: require("../assets/images/chara/Gehenna.png") },
      { a: require("../assets/images/chara/Millennium.png") },
      { a: require("../assets/images/chara/Trinity.png") },
    ], //学院按钮
    siYuans: [
      { a: require("../assets/images/college/Abydos.png") },
      { a: require("../assets/images/college/Gehenna.png") },
      { a: require("../assets/images/college/Millennium.png") },
      { a: require("../assets/images/college/Trinity.png") },
    ], //学院按钮
    changeRed: 0,
    swiperOption: {
      // loop: true,
      autoplay: 3000,
      direction: "horizontal",
      autoHeight: true,
      navigation: {
        //最新版本的需要这样配置，按钮才有效
        prevEl: ".swiper-button-prev", //上一张
        nextEl: ".swiper-button-next", //下一张
      },
    },
    voice: 0,
    pager: 0,
    College: [
      {
        rolelist: [
          {
            bannerUrl: require("../assets/images/chara/c1.png"),
            logo: require("../assets/images/chara/ab.png"),
            title: "シロコ",
            name: "CV:小倉唯",
            college: "学園:アビドス高等学校",
            age: "学年:2年",
            birthday: "誕生日:5月16日",
            stature: "身長:156cm",
            audio1: require("../assets/mp3/01/01.wav"),
          },
          {
            bannerUrl: require("../assets/images/chara/c2.png"),
            logo: require("../assets/images/chara/ab.png"),
            title: "ホシノ",
            name: "CV:花守ゆみり",
            college: "学園:アビドス高等学校",
            age: "学年:3年",
            birthday: "誕生日:1月2日",
            stature: "身長:145cm",
            audio1: require("../assets/mp3/01/02.wav"),
          },
          {
            bannerUrl: require("../assets/images/chara/c3.png"),
            logo: require("../assets/images/chara/ab.png"),
            title: "セリカ",
            name: "CV:大橋彩香",
            college: "学園:アビドス高等学校",
            age: "学年:1年",
            birthday: "誕生日:6月25日",
            stature: "身長:153cm",
            audio1: require("../assets/mp3/01/03.wav"),
          },
          {
            bannerUrl: require("../assets/images/chara/c4.png"),
            logo: require("../assets/images/chara/ab.png"),
            title: "ノノミ",
            name: "CV:三浦千幸",
            college: "学園:アビドス高等学校",
            age: "学年:2年",
            birthday: "誕生日:9月1日",
            stature: "身長:160cm",
            audio1: require("../assets/mp3/01/04.wav"),
          },
        ],
        chara: [
          {
            chara1: require("../assets/images/chara/a1.png"),
          },
          {
            chara1: require("../assets/images/chara/a2.png"),
          },
          {
            chara1: require("../assets/images/chara/a3.png"),
          },
          {
            chara1: require("../assets/images/chara/a4.png"),
          },
        ],
      },
      {
        rolelist: [
          {
            bannerUrl: require("../assets/images/chara/c5.png"),
            logo: require("../assets/images/chara/ge.png"),
            title: "ヒナ",
            name: "CV:広橋涼",
            college: "学園:ゲヘナ学園",
            age: "学年:3年",
            birthday: "誕生日:2月19日",
            stature: "身長:142cm",
            audio1: require("../assets/mp3/02/01.wav"),
            changeRed: "test",
          },
          {
            bannerUrl: require("../assets/images/chara/c6.png"),
            logo: require("../assets/images/chara/ge.png"),
            title: "アル",
            name: "CV:近藤玲奈",
            college: "学園:ゲヘナ学園",
            age: "学年:2年",
            birthday: "誕生日:3月12日",
            stature: "身長:160cm",
            audio1: require("../assets/mp3/02/02.wav"),
            changeRed: "test0",
          },
          {
            bannerUrl: require("../assets/images/chara/c7.png"),
            logo: require("../assets/images/chara/ge.png"),
            title: "ジュンコ",
            name: "CV:金元寿子",
            college: "学園:ゲヘナ学園",
            age: "学年:1年",
            birthday: "誕生日:12月27日",
            stature: "身長:149cm",
            audio1: require("../assets/mp3/02/03.wav"),
          },
        ],
        chara: [
          {
            chara1: require("../assets/images/chara/a5.png"),
          },
          {
            chara1: require("../assets/images/chara/a6.png"),
          },
          {
            chara1: require("../assets/images/chara/a7.png"),
          },
        ],
      },
      {
        rolelist: [
          {
            bannerUrl: require("../assets/images/chara/c12.png"),
            logo: require("../assets/images/chara/mi.png"),
            title: "ユウカ",
            name: "CV:春花らん",
            college: "学園:ミレニアムサイエンススクール",
            age: "学年:2年",
            birthday: "誕生日:3月14日",
            stature: "身長:156cm",
            audio1: require("../assets/mp3/04/01.wav"),
          },
          {
            bannerUrl: require("../assets/images/chara/c13.png"),
            logo: require("../assets/images/chara/mi.png"),
            title: "カリン",
            name: "CV:沼倉愛美",
            college: "学園:ミレニアムサイエンススクール",
            age: "学年:2年",
            birthday: "誕生日:2月2日",
            stature: "身長:170cm",
            audio1: require("../assets/mp3/04/02.wav"),
          },
          {
            bannerUrl: require("../assets/images/chara/c14.png"),
            logo: require("../assets/images/chara/mi.png"),
            title: "エイミ",
            name: "CV:松永あかね",
            college: "学園:ミレニアムサイエンススクール",
            age: "学年:1年",
            birthday: "誕生日:5月1日",
            stature: "身長:167cm",
            audio1: require("../assets/mp3/04/03.wav"),
            changeRed: "test1",
          },
        ],
        chara: [
          {
            chara1: require("../assets/images/chara/a12.png"),
          },
          {
            chara1: require("../assets/images/chara/a13.png"),
          },
          {
            chara1: require("../assets/images/chara/a14.png"),
          },
        ],
      },
      {
        rolelist: [
          {
            bannerUrl: require("../assets/images/chara/c8.png"),
            logo: require("../assets/images/chara/tr.png"),
            title: "ヒフミ",
            name: "CV:本渡楓",
            college: "学園:トリニティ総合学園",
            age: "学年:2年",
            birthday: "誕生日:11月27日",
            stature: "身長:158cm",
            audio1: require("../assets/mp3/03/01.wav"),
          },
          {
            bannerUrl: require("../assets/images/chara/c9.png"),
            logo: require("../assets/images/chara/tr.png"),
            title: "ハスミ",
            name: "CV:瀬戸麻沙美",
            college: "学園:トリニティ総合学園",
            age: "学年:3年",
            birthday: "誕生日:12月12日",
            stature: "身長:179cm",
            audio1: require("../assets/mp3/03/02.wav"),
            changeRed: "test2",
          },
          {
            bannerUrl: require("../assets/images/chara/c10.png"),
            logo: require("../assets/images/chara/tr.png"),
            title: "セリナ",
            name: "CV:涼本あきほ",
            college: "学園:トリニティ総合学園",
            age: "学年:2年",
            birthday: "誕生日:1月6日",
            stature: "身長:156cm",
            audio1: require("../assets/mp3/03/03.wav"),
          },
          {
            bannerUrl: require("../assets/images/chara/c11.png"),
            logo: require("../assets/images/chara/tr.png"),
            title: "アイリ",
            name: "CV:杉村ちか子",
            college: "学園:トリニティ総合学園",
            age: "学年:1年",
            birthday: "誕生日:1月30日",
            stature: "身長:160cm",
            audio1: require("../assets/mp3/03/04.wav"),
          },
        ],
        chara: [
          {
            chara1: require("../assets/images/chara/a8.png"),
          },
          {
            chara1: require("../assets/images/chara/a9.png"),
          },
          {
            chara1: require("../assets/images/chara/a10.png"),
          },
          {
            chara1: require("../assets/images/chara/a11.png"),
          },
        ],
      },
    ], //轮播内容
    swiperDom: null,
    vals: "",
    audio1playing: false,
    audio2playing: false,
  }),
  created() {},
  mounted() {
    this.swiperDom = this.swiper;
  },
  watch: {
    changeRed(to) {
      this.swiper.slideTo(0, 1000, false);
    },
    // swiper_activeIndex(val, oldVal) {
    //   if (oldVal == undefined) {
    //   } else {
    //     console.log(val, oldVal);
    //     this.$refs[`audio1_${oldVal}`][0].pause();
    //     this.$refs[`audio2_${oldVal}`][0].pause();
    //     this.$refs[`audio1_${oldVal}`][0].currentTime = 0;
    //     this.$refs[`audio2_${oldVal}`][0].currentTime = 0;
    //   }
    // },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    // swiper_activeIndex() {
    //   if (this.swiperDom) {
    //     return this.swiperDom.realIndex;
    //   }
    // },
  },
  methods: {
    changeVoice(num) {
      this.voice = num;
    },
    play(index) {
      this.$refs.audio1[index].pause();
      this.$refs.audio1[index].currentTime = 0;
      this.$refs.audio1[index].play();
    },
    change(index) {
      this.changeRed = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.character {
  width: 100%;
  font-size: pxTorem(50px);
  height: pxTorem(1080px);
  background: url(../assets/images/home/character_bk.png);
  background-size: 100% 100%;
  display: flex;
  .character_left {
    margin-left: pxTorem(128px);
    z-index: 2;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    width: pxTorem(338px);
    box-sizing: border-box;
    padding: pxTorem(100px) 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    .College-logo {
      margin: 0 auto;
      width: pxTorem(170px);
      cursor: pointer;
      opacity: 0.6;
    }
    .red {
      width: pxTorem(200px);
      opacity: 1;
    }
  }
  .character_lefts {
    display: none;
  }
  .character_right {
    .swipers {
      position: relative;
      width: pxTorem(1394px);
      height: 100%;
      .swiper_s {
        margin-left: pxTorem(64px);
        // background: white;
        // width: pxTorem(1394px);
        height: 100%;
        .character {
          background: rgba(255, 255, 255, 0);
          width: pxTorem(1394px);
          position: relative;
          .character_l {
            .mens {
              position: absolute;
              bottom: 0;
              height: pxTorem(995px);
              right: pxTorem(-0px);
            }
          }
          .character_r {
            position: relative;
            z-index: 3;
            margin-top: pxTorem(234px);
            float: left;
            height: pxTorem(474px);
            width: pxTorem(815px);
            background: url(../assets/images/chara/studentid.png);
            background-size: 100% 100%;
            text-align: left;
            color: #7b7b7b;
            box-sizing: border-box;
            padding-top: pxTorem(94px);
            padding-left: pxTorem(64px);
            font-family: "Noto Sans JP", sans-serif;
            font-weight: 400;
            .Useless {
              display: none;
              @media screen and (max-width: 600px) {
                display: block;
                height: 100px;
              }
            }
            .shiroko {
              display: none;
            }
            .title {
              line-height: pxTorem(39px);
              font-size: pxTorem(39px);
              font-weight: 600;
            }
            .name {
              margin-top: pxTorem(26px);
              margin-bottom: pxTorem(42px);
            }
            .college-logo {
              width: pxTorem(120px);
              right: pxTorem(84px);
              top: pxTorem(168px);
              position: absolute;
            }
            .Campusinfo {
              font-size: pxTorem(26px);
              line-height: pxTorem(40px);
            }
            .frequency {
              margin-top: pxTorem(10px);
              margin-bottom: pxTorem(20px);
              height: pxTorem(43px);
              display: flex;
              justify-content: center;

              .frequencys {
                height: pxTorem(40px);
                width: pxTorem(180px);
                position: absolute;
                margin-top: pxTorem(5px);
                right: 5%;
                .voiceFrequency {
                  position: absolute;
                  width: 107%;
                  cursor: pointer;
                  height: 130%;
                  z-index: 999;
                  top: -60%;
                }
                .sound {
                  top: 5%;
                  left: 0%;
                  position: absolute;
                  width: pxTorem(128px);
                }
                .maiku {
                  cursor: pointer;
                  top: -56%;
                  right: -2%;
                  position: absolute;
                  width: pxTorem(33px);
                }
                .VOICE {
                  width: 100%;
                  height: 100%;
                  margin-bottom: pxTorem(17px);
                }
                .VOICEs {
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  opacity: 0;
                  transition: opacity 0.3s ease-in-out;
                  @media screen and (min-width: 600px) {
                    &:hover {
                      opacity: 1;
                    }
                  }
                }
              }
              .frequency_l {
                margin-right: pxTorem(13px);
              }
            }
            .scroll {
              box-sizing: border-box;
              padding: pxTorem(55px) pxTorem(75px) 0;
              height: pxTorem(322px);
              background-size: 100% 100%;
              position: relative;
              .mini {
                position: absolute;
                width: pxTorem(180px);
                right: pxTorem(-96px);
                bottom: pxTorem(-2px);
                z-index: 666;
              }
            }
          }
        }
      }
    }
    .imgs_s {
      z-index: 2;
      // background: violet;
      height: pxTorem(164px);
      width: pxTorem(1039px);
      position: absolute;
      bottom: pxTorem(33px);
      left: pxTorem(64px);
      display: flex;
      justify-content: space-between;
      a {
        width: pxTorem(164px);
        height: pxTorem(164px);
        display: inline-block;
        margin: 0 10px;
        position: relative;
        cursor: pointer;

        .pager {
          width: 100%;
          height: 100%;
          border-radius: 15.5%;
        }
        .pagers {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0;
          background: rgba(0, 0, 0, 0.3);
          transition: opacity 0.3s ease-in-out;
          border-radius: 15.5%;
          &:hover {
            opacity: 1;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .character {
    overflow: hidden;
    width: 100%;
    font-size: MpxTorem(50px);
    height: MpxTorem(1920px);
    background: url(../assets/images/home/character_bks.png);
    background-size: 100% 100%;
    display: block;

    .character_left {
      display: none;
    }
    .character_lefts {
      margin-left: MpxTorem(43px);
      margin-top: MpxTorem(206px);
      z-index: 2;
      height: MpxTorem(216px);
      background: rgba(255, 255, 255, 0);
      width: MpxTorem(757px);
      box-sizing: border-box;
      padding: 0;
      display: block;
      .College-logo {
        margin: 0 auto;
        width: MpxTorem(152px);
        cursor: pointer;
        opacity: 0.6;
        background: #ffff;
        margin-right: MpxTorem(29px);
        border-radius: MpxTorem(15px);
      }
      .College-logo:last-child {
        margin-right: MpxTorem(0px);
      }
      .red {
        width: MpxTorem(212px);
        opacity: 1;
      }
    }
    .character_right {
      .swipers {
        position: relative;
        width: 100%;
        height: 100%;
        .swiper_s {
          margin-left: MpxTorem(0px);
          // background: white;
          // width: pxTorem(1394px);
          height: 100%;
          .character {
            background: rgba(255, 255, 255, 0);
            width: MpxTorem(1394px);
            position: relative;
            .character_l {
              .mens {
                // width: MpxTorem(1003px);
                position: absolute;
                top: MpxTorem(0px);
                left: MpxTorem(270px);
                height: MpxTorem(2028px);
              }
              .test {
                top: MpxTorem(0px);
                left: MpxTorem(-750px);
              }
              .test0 {
                left: MpxTorem(150px);
              }
              .test1 {
                left: MpxTorem(90px);
              }
              .test2 {
                top: MpxTorem(-50px);
                left: MpxTorem(-500px);
                height: MpxTorem(2428px);
              }
            }
            .character_r {
              position: relative;
              z-index: 10;
              margin-top: MpxTorem(276px);
              display: block;
              height: MpxTorem(640px);
              width: MpxTorem(524px);
              background: rgba(255, 255, 255, 0);
              background-size: 100% 100%;
              text-align: left;
              color: white;
              box-sizing: border-box;
              padding-top: 0;
              padding-left: MpxTorem(36.4px);
              background: rgba(12, 185, 243, 0.3);
              font-family: "Noto Sans JP", sans-serif;
              font-weight: 400;
              .title-s {
                // display: none;
                line-height: MpxTorem(39px);
                font-size: MpxTorem(70px);
                font-weight: 600;
                position: absolute;
                left: MpxTorem(73px);
                top: MpxTorem(126px);
              }
              .shiroko {
                left: MpxTorem(30px);
                top: MpxTorem(80px);
                display: block;
                position: absolute;
                width: MpxTorem(445px);
              }
              .name {
                font-size: MpxTorem(40px);
                margin-top: MpxTorem(233px);
                margin-bottom: MpxTorem(130px);
                margin-left: MpxTorem(40px);
              }
              .college-logo {
                display: none;
                width: MpxTorem(120px);
                right: MpxTorem(84px);
                top: MpxTorem(168px);
                position: absolute;
              }
              .Campusinfo {
                font-size: MpxTorem(28px);
                line-height: MpxTorem(42px);
              }
              .frequency {
                margin-top: MpxTorem(10px);
                margin-bottom: MpxTorem(20px);
                height: MpxTorem(43px);
                display: flex;
                justify-content: center;
                .frequencys {
                  left: 0;
                  top: 50%;
                  height: MpxTorem(43px);
                  width: MpxTorem(180px);
                  position: absolute;
                  margin-top: MpxTorem(5px);
                  .voiceFrequency {
                    width: 108%;
                  }
                  .sound {
                    top: 20%;
                    left: 50%;
                    position: absolute;
                    width: MpxTorem(110px);
                  }
                  .maiku {
                    cursor: pointer;
                    top: -20%;
                    right: 65%;
                    position: absolute;
                    width: MpxTorem(24px);
                  }
                  .VOICE {
                    width: 100%;
                    height: 100%;
                    margin-bottom: pxTorem(17px);
                  }
                  .VOICEs {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    opacity: 0;
                    transition: opacity 0.3s ease-in-out;
                    @media screen and (min-width: 600px) {
                      &:hover {
                        opacity: 1;
                      }
                    }
                  }
                }
                .frequency_l {
                  margin-right: pxTorem(13px);
                }
              }
              .scroll {
                box-sizing: border-box;
                padding: pxTorem(55px) pxTorem(75px) 0;
                height: pxTorem(322px);
                background-size: 100% 100%;
                position: relative;
                .mini {
                  position: absolute;
                  width: pxTorem(180px);
                  right: pxTorem(-96px);
                  bottom: pxTorem(-2px);
                  z-index: 666;
                }
              }
            }
          }
        }
      }
      .imgs_s {
        z-index: 2;

        height: MpxTorem(202px);
        width: 100%;
        position: absolute;
        bottom: MpxTorem(550px);
        left: pxTorem(0px);
        display: flex;
        justify-content: space-between;
        a {
          width: MpxTorem(168px);
          height: MpxTorem(168px);
          display: inline-block;
          margin: 0 10px;
          position: relative;
          .pager {
            width: 100%;
            height: 100%;
          }
          .pagers {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            transition: opacity 0.3s ease-in-out;

            &:hover {
              opacity: 1;
            }

            // &.active {
            //     opacity: 1;
            // }
          }
        }
      }
    }
  }
}
</style>
